#
# The images browser working in modal
#
class @ImagesBrowser

  @setup: (container, inject) ->
    new @ container, inject

  constructor: (container, @inject) ->
    @$container = $(container)
    @$header    = $('.modal-header', @$container)
    @$content   = $('.modal-body', @$container)
    @$footer    = $('.modal-footer', @$container)
    @csrf       = $('meta[name=csrf-token]').attr('content')

    @campaignId      = @$container.data('campaign-id')
    @autoresponderId = @$container.data('autoresponder-id')

    if @campaignId
      @route = Routes.campaign_campaign_images_path(@campaignId)
    else if !isNil(@autoresponderId)
      if @autoresponderId
        @route = Routes.autoresponder_autoresponder_images_path(@autoresponderId)
      else
        Dialogs.presentAlertModal(t("notices.no_images_on_unsaved_autoresponders"), null, t("notices.no_images_on_unsaved_autoresponders_title"))
        return
    else
      Dialogs.presentAlertModal(t("notices.no_images_on_unsaved_records"))
      return

    @$container.modal()
    @setupOcupload()
    @reset()

    $(window).off '.ImagesBrowser'
    $(window).on 'resize.ImagesBrowser', =>
      unless @loaded
        @reset()
      else
        @adjustHeight()

    self = @

    @$container.off '.ImagesBrowser'

    @$container.on 'click.ImagesBrowser', '.icon-pencil', ->
      $(@).closest('.name').hide().next().show()

    @$container.on 'click.ImagesBrowser', '.icon-remove', ->
      if confirm(t 'images_browser.actions.remove', file_name: $(@).data('file-name'))
        id = $(@).closest('.actions').data('id')
        $.ajax
          url: self.route+'/'+id
          type: 'delete'
          success: (html) -> self.html html

    @$container.on 'click.ImagesBrowser', '.icon-remove-sign', ->
      $(@).closest('form').hide().prev().show()

    @$container.on 'click.ImagesBrowser', '.icon-ok-sign', ->
      $(@).closest('form').submit()

    @$container.on 'keypress', '.meta input', (e) ->
      if e.which == 13
        e.preventDefault()
        e.stopPropagation()
        $(@).closest('form').submit()

    @$container.on 'click.ImagesBrowser', '.preview .title, .image a', (event) ->
      event.preventDefault()
      self.$container.modal('hide')
      self.inject? $(@).closest('.preview').find('img').data('href')

    @$container.on 'ajax:error.ImagesBrowser', 'form', ->
      $(@).reset()
      $(@).hide().prev().show()

    @$container.on 'ajax:success.ImagesBrowser', 'form', ->
      $(@).prev().find('.title').html $(@).find('input[type=text]').val()
      $(@).hide().prev().show()

    @refresh()

  setupOcupload: ->
    $button = @$footer.find '.button'
    return if $button.data('initialized')

    $button.upload
      params: { authenticity_token: @csrf }
      action: @route
      onSubmit: () =>
        setTimeout (=>
          @$footer.find('.actions').hide()
          new Spinner().spin(@$footer.find('.spinner').show().html('')[0])
        ), 0
      onComplete: (html) =>
        @html html
        @$footer.find('.spinner').hide()
        @$footer.find('.actions').show()
    $button.data('initialzed', true)

  reset: ->
    @loaded = false
    @$content.html ''
    @adjustHeight()
    new Spinner().spin(@$content[0])

  adjustHeight: ->
    @$content.css 'height',
      (@$container.height() - @$header.outerHeight() - @$footer.outerHeight()) + 'px'

  refresh: ->
    $.get @route, (html) =>
      @loaded = true
      @html html

  html: (html) ->
    self = @
    @$content.html html

    $('i.icon-upload-alt', @$content).each ->
      id = $(@).closest('.actions').data('id')

      $(@).upload
        action: "#{self.route}/#{id}"
        params: {'authenticity_token': self.csrf}
        onComplete: (html) -> self.html(html)
